// PopupComponent.jsx
import React from "react";
import "./modalComponent.scss";
import Button from "../button/buttonComponent";

const Modal = ({
    isVisible = false,
    onClose,
    type = "default",
    header = false,
    // subheader = false,
    positiveButtonAction = false,
    positiveButtonLabel = false,
    neutralButtonAction = false,
    neutralButtonLabel = false,
    cancelButtonAction = false,
    cancelButtonLabel = false,
    negativeButtonAction = false,
    negativeButtonLabel = false,
    notes = false,
    className,
    children
}) => {

  return (
    <div className={"customModalWrapper " + className + " " + (isVisible ? "visible" : "") + " " + type}>
        <div className="customModalOverlay" onClick={onClose}></div>
        
        <div className="customModalContentWrapper">
            <div className="customModalHeader">
                <div className="modalTitle">{header}</div>
                <div className="modalClose" onClick={onClose}>
                    <i className="fa fa-times"></i>
                </div>
            </div>

            <div className="customModalContent">
                {children}
            </div>


            <div className="customModalFooter">
                <div className="left">
                    {
                        notes ?
                        <div className="note">
                            <i className="fa fa-info-circle"></i> <span>{notes}</span>
                        </div> : ""
                    }
                </div>
                
                <div className="right">
                    { cancelButtonLabel ? <Button className={"small white"} onClick={() => cancelButtonAction?.()}><span>{cancelButtonLabel}</span></Button> : "" }
                    { negativeButtonLabel ? <Button className={"small red"} onClick={() => negativeButtonAction?.()}><span>{negativeButtonLabel}</span></Button> : "" }
                    { positiveButtonLabel ? <Button className={"small"} onClick={() => positiveButtonAction?.()}><span>{positiveButtonLabel}</span></Button> : "" }
                    { neutralButtonLabel ? <Button className={"small white"} onClick={() => neutralButtonAction?.()}><span>{neutralButtonLabel}</span></Button> : "" }
                </div>
            </div>
        </div>
    </div>
  );
};

export default Modal;
